import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import { Select, DatePicker, Card, Tooltip } from "antd";

import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import MapComponent from "../../components/OperationManagement/MapComponent";

import { BsFillPatchPlusFill } from "react-icons/bs";
import { IoArrowBack } from "react-icons/io5";

import SideBar from "../../components/SideBar";
import {
  listOfMatricul,
  listOfResponsable,
  getAllVehicul,
} from "../../api/data/Vehiculs";

import { getAllCityApi } from "../../api/city";
import { getGeoLocationApi } from "../../api/map";
import { useNavigate } from "react-router-dom";
import { addNewOperationApi } from "./../../api/operationManagemment"

import { socket } from './../../socket';

import Swal from 'sweetalert2';

const { Option } = Select;
const { RangePicker } = DatePicker;

function NewOperationManagement() {
  const navigate = useNavigate();

  const position = [30.379245, -9.520939];

  const [startPosition, setStartPosition] = useState({});
  const [endPosition, setEndPosition] = useState({});

  const [cityData, setCityData] = useState([]);

  const [vehiculData, setVehiculData] = useState([]);
  const [responsableData, setResponsableData] = useState([]);
  const [matriculData, setMatriculData] = useState([]);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [userForm, setUserForm] = useState({
    startCityName: "",
    startCityLocation: {},
    arrivedCityName: "",
    arrivedCityLocation: {},

    selectedModel: "",
    selectedConducteur: "",
    selectedMatricule: "",

    SelectedFromDate: "",
    SelectedToDate: "",
  });

  const [isConnected, setIsConnected] = useState(socket.connected);

  useEffect(() => {
    getAllInitialData();

    const onConnect = () => {
      setIsConnected(true);
    }
    const onDisconnect = () => {
      setIsConnected(false);
    }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
    };
  }, []);

  const getAllInitialData = async () => {
    try {
      const cityRes = await getAllCityApi();
      setCityData(Array.isArray(cityRes) ? cityRes : []);
    } catch(err) { setCityData([]) }

    try {
      const matriculDataRes = await listOfMatricul();
      setMatriculData(Array.isArray(matriculDataRes) ? matriculDataRes : []);
    } catch(err) { setMatriculData([]) }

    try {
      const responsableDataRes = await listOfResponsable();
      setResponsableData(Array.isArray(responsableDataRes) ? responsableDataRes : []);
    } catch(err) { setResponsableData([]) }

    try {
      const vehiculDataRes = await getAllVehicul();
      setVehiculData(Array.isArray(vehiculDataRes) ? vehiculDataRes : []);
    } catch(err) { setVehiculData([]) }
  };

  const handleDateChange = (selectedDate, selectedFormatedDate) => {
    if (selectedDate) {
      setUserForm({
        ...userForm,
        SelectedFromDate: selectedFormatedDate[0],
        SelectedToDate: selectedFormatedDate[1]
      });
    }
  };

  const handleSelectInputChangeFrom = async (e) => {
    if (!e) {
      setStartPosition({});
      setUserForm({ ...userForm, startCityName: "", startCityLocation: null });
      return;
    }

    const geoResults = await getGeoLocationApi(e);
    const match = Array.isArray(geoResults) ? geoResults[0] : null;
    const location = match ? { lat: match.lat, lng: match.lon } : null;

    if (location) {
      setStartPosition(location)
    }

    setUserForm({
      ...userForm,
      startCityName: e,
      startCityLocation: location,
    });
  };

  const handleSelectInputChangeTo = async (e) => {
    if (!e) {
      setEndPosition({});
      setUserForm({ ...userForm, arrivedCityName: "", arrivedCityLocation: null });
      return;
    }

    const geoResults = await getGeoLocationApi(e);
    const match = Array.isArray(geoResults) ? geoResults[0] : null;
    const location = match ? { lat: match.lat, lng: match.lon } : null;

    if (location) {
      setEndPosition(location)
    }

    setUserForm({
      ...userForm,
      arrivedCityName: e,
      arrivedCityLocation: location,
    });
  };

  const handleVehiculeChange = (value) => {
    if (!value) {
      setUserForm({ ...userForm, selectedModel: '', selectedConducteur: '', selectedMatricule: '' })
      return
    }

    const selectedVehicul = vehiculData.find(el => el._id === value)
    if (!selectedVehicul) return

    setUserForm({
      ...userForm,
      selectedModel: selectedVehicul._id,
      selectedConducteur: selectedVehicul.responsable?._id || '',
      selectedMatricule: selectedVehicul.immatriculation?._id || '',
    })
  }

  const handleConducteurChange = (value) => {
    setUserForm({ ...userForm, selectedConducteur: value || '' })
  }

  const handleMatriculeChange = (value) => {
    setUserForm({ ...userForm, selectedMatricule: value || '' })
  }

  const handleSubmitForm = async e => {
    e.preventDefault()

    if (!userForm.startCityLocation || !userForm.arrivedCityLocation) {
      return Swal.fire({
        title: 'Ville introuvable',
        text: "Impossible de localiser la ville de départ ou d'arrivée sur la carte. Resélectionnez-la dans la liste.",
        icon: 'error'
      });
    }

    setIsSubmitting(true)

    try {
      const response = await addNewOperationApi(userForm.startCityName, userForm.startCityLocation, userForm.arrivedCityName, userForm.arrivedCityLocation, userForm.selectedModel, userForm.selectedConducteur, userForm.selectedMatricule, userForm.SelectedFromDate, userForm.SelectedToDate)

      if(!response) {
        return Swal.fire({
            title: 'Erreur!',
            text: 'Server error',
            icon: 'error'
        });
      }

      Swal.fire({
          title: 'Opération créée',
          text: '',
          icon: 'success'
      });

      socket.emit('direction-event');

      navigate("/admin/missionOrder/" + response._id);
    }
    catch(err) {
      Swal.fire({
        title: 'Erreur!',
        text: err.response.data.error,
        icon: 'error'
      });
    }
    finally {
      setIsSubmitting(false)
    }
  };

  const handleReddirection = (value) => {
    navigate(`/admin/${value}`);
  };

  return (
    <Fragment>
      <section className="NewOperationManagementSection newOperationForm">
        <Row>
          <Col md="2" className="p-0">
            <SideBar />
          </Col>
          <Col md="10" className="p-0">
            <div className="formHeader">
              <button type="button" className="backLink" onClick={() => navigate('/admin/gestionOP')}>
                <IoArrowBack /> Retour aux trajets
              </button>
              <span className="eyebrow">Gestion des opérations</span>
              <h1>Nouvelle opération</h1>
            </div>
            <Row>
              <Col md="8">
                <div className="leftSideContents">
                  <Card bordered={false}>
                    <div className="formSection">
                      <span className="sectionEyebrow">Itinéraire</span>
                      <div className="rowContents">
                        <div className="fieldGroup">
                          <label>Ville de départ</label>
                          <Select
                            showSearch
                            allowClear
                            placeholder="Choisir une ville"
                            optionFilterProp="children"
                            onChange={handleSelectInputChangeFrom}
                            value={userForm.startCityName || undefined}
                          >
                            {cityData.map((el) => (
                              <Option key={el._id} value={el.ville}>{el.ville}</Option>
                            ))}
                          </Select>
                        </div>

                        <div className="fieldGroup">
                          <label>Ville d'arrivée</label>
                          <Select
                            showSearch
                            allowClear
                            placeholder="Choisir une ville"
                            optionFilterProp="children"
                            onChange={handleSelectInputChangeTo}
                            value={userForm.arrivedCityName || undefined}
                          >
                            {cityData.map((el) => (
                              <Option key={el._id} value={el.ville}>{el.ville}</Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </div>

                    <div className="formSection">
                      <span className="sectionEyebrow">Ressources affectées</span>

                      <div className="fieldRow">
                        <div className="fieldGroup grow">
                          <label>Véhicule</label>
                          <Select
                            showSearch
                            allowClear
                            placeholder="Choisir un véhicule"
                            optionFilterProp="children"
                            onChange={handleVehiculeChange}
                            value={userForm.selectedModel || undefined}
                            id="selectedModelID"
                          >
                            {vehiculData.map((el) => (
                              <Option key={el._id} value={el._id}>{el.marque}</Option>
                            ))}
                          </Select>
                        </div>
                        <Tooltip title="Ajouter un véhicule">
                          <button type="button" className="addFieldBtn" onClick={() => handleReddirection("newFloat")}>
                            <BsFillPatchPlusFill size="16" />
                          </button>
                        </Tooltip>
                      </div>

                      <div className="fieldRow">
                        <div className="fieldGroup grow">
                          <label>Conducteur</label>
                          <Select
                            showSearch
                            allowClear
                            placeholder="Choisir un conducteur"
                            optionFilterProp="children"
                            onChange={handleConducteurChange}
                            value={userForm.selectedConducteur || undefined}
                          >
                            {responsableData.map((el) => (
                              <Option key={el._id} value={el._id}>{el.firstName} {el.lastName}</Option>
                            ))}
                          </Select>
                          {userForm.selectedModel && (
                            <span className="autoHint">Pré-rempli depuis le véhicule — modifiable</span>
                          )}
                        </div>
                        <Tooltip title="Ajouter un conducteur">
                          <button type="button" className="addFieldBtn" onClick={() => handleReddirection("newResponsable")}>
                            <BsFillPatchPlusFill size="16" />
                          </button>
                        </Tooltip>
                      </div>

                      <div className="fieldRow">
                        <div className="fieldGroup grow">
                          <label>Immatriculation</label>
                          <Select
                            showSearch
                            allowClear
                            placeholder="Choisir un numéro de matricule"
                            optionFilterProp="children"
                            onChange={handleMatriculeChange}
                            value={userForm.selectedMatricule || undefined}
                          >
                            {matriculData.map((el) => (
                              <Option key={el._id} value={el._id}>{el.immatriculation}</Option>
                            ))}
                          </Select>
                          {userForm.selectedModel && (
                            <span className="autoHint">Pré-rempli depuis le véhicule — modifiable</span>
                          )}
                        </div>
                        <Tooltip title="Ajouter un document">
                          <button type="button" className="addFieldBtn" onClick={() => handleReddirection("newDocument")}>
                            <BsFillPatchPlusFill size="16" />
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div className="formSection">
                      <span className="sectionEyebrow">Planification</span>
                      <div className="fieldGroup">
                        <label>Période</label>
                        <RangePicker showTime onChange={handleDateChange} style={{ width: '100%' }} placeholder={['Départ', 'Arrivée']} />
                      </div>
                    </div>

                    <div className="formFooter">
                      <Button className="submitBtn" onClick={handleSubmitForm} disabled={isSubmitting}>
                        {isSubmitting ? 'Création…' : "Créer l'opération"}
                      </Button>
                    </div>
                  </Card>
                </div>
              </Col>
              <Col md="4">
                <div className="rightSideTabContent">
                  <p className="mapCaption">
                    {userForm.startCityName && userForm.arrivedCityName
                      ? `${userForm.startCityName} → ${userForm.arrivedCityName}`
                      : "Choisissez une ville de départ et d'arrivée pour visualiser l'itinéraire"}
                  </p>
                  <MapContainer center={position} zoom={13} style={{ height: "84vh" }}>
                    <TileLayer
                      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <MapComponent
                      startPoint={startPosition}
                      endPoint={endPosition}
                    />
                  </MapContainer>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </Fragment>
  );
}

export default NewOperationManagement;
